import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterSection = _resolveComponent("FilterSection")!
  const _component_NTable = _resolveComponent("NTable")!
  const _component_ListPage = _resolveComponent("ListPage")!

  return (_openBlock(), _createBlock(_component_ListPage, {
    state: _ctx.state,
    statistics: false,
    "onUpdate:scrollBottom": _ctx.scrollBottomHandler,
    class: "audit-logs"
  }, {
    filters: _withCtx(() => [
      _createVNode(_component_FilterSection, {
        filter: _ctx.module.filter,
        "scheme-small": _ctx.smallFilterSchema,
        "scheme-large": _ctx.bigFilterSchema,
        "has-report": "",
        hasPinnedFields: "",
        "default-pinned-fields": _ctx.defaultPinnedFields
      }, null, 8, ["filter", "scheme-small", "scheme-large", "default-pinned-fields"])
    ]),
    items: _withCtx(() => [
      _createVNode(_component_NTable, {
        class: "audit-logs__table",
        columns: _ctx.tableSchema,
        content: _ctx.items,
        "data-qa": "audit_logs.table",
        onCellClick: _ctx.handleTableAction
      }, null, 8, ["columns", "content", "onCellClick"])
    ]),
    "items-empty": _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["state", "onUpdate:scrollBottom"]))
}